/**
 * CRM Module — Contact Channel Type Constants
 *
 * Единый список типов каналов связи (телефон, email, мессенджеры, сайт и т.д.).
 * Используется и на сервере (ContactChannelRepository), и на фронте
 * (ChannelManager) — общее место, чтобы список не расходился.
 */

export const CHANNEL_TYPES = [
  { value: 'phone', label: 'Телефон', icon: 'phone' },
  { value: 'email', label: 'Email', icon: 'mail' },
  { value: 'whatsapp', label: 'WhatsApp', icon: 'phone' },
  { value: 'telegram', label: 'Telegram', icon: 'mail' },
  { value: 'linkedin', label: 'LinkedIn', icon: 'mail' },
  { value: 'facebook', label: 'Facebook', icon: 'mail' },
  { value: 'skype', label: 'Skype', icon: 'phone' },
  { value: 'viber', label: 'Viber', icon: 'phone' },
  { value: 'website', label: 'Веб-сайт', icon: 'mail' },
  { value: 'instagram', label: 'Instagram', icon: 'mail' },
  { value: 'twitter', label: 'Twitter', icon: 'mail' },
  { value: 'youtube', label: 'YouTube', icon: 'mail' },
] as const;

export type ChannelType = (typeof CHANNEL_TYPES)[number]['value'];
